// removed by extract-text-webpack-plugin
module.exports = {"guideDetailEditor":"_3YbnW","guideDetailEditorTextarea":"_1DDN5 _2QXSI _1bHiY _2Eplg _2vAMF"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/GuideDetailEditor.css
// module id = 1186
// module chunks = 3